/* eslint-disable no-underscore-dangle */
export * from './@types';
export * from './components';
export * from './contexts';
export * from './constants';
export * from './LegacyMount';

declare global {
  // eslint-disable-next-line
  const __PT_BUILD_VERSION__: string;
  // eslint-disable-next-line
  const __PT_BUILD_DATE__: string;
}

/**
 * Returns true if __debug_mode is set to true in localStorage.
 */
export const isDebugMode = () => {
  const debugMode = localStorage.getItem('__debug_mode');
  return debugMode === 'true' || debugMode === '1' || debugMode === 't';
};

if (isDebugMode()) {
  let version = 'unknown';
  let buildDate = 'unknown';

  try {
    version = __PT_BUILD_VERSION__;
  } catch (err) {
    if (isDebugMode()) {
      console.warn('[pt] Failed to retrieve build version:', err);
    }
  }
  try {
    buildDate = __PT_BUILD_DATE__;
  } catch (err) {
    if (isDebugMode()) console.warn('[pt] Failed to retrieve build date:', err);
  }

  console.log('************************************************');
  console.log('   Card Tokenization component loaded.');
  console.log('   Build version:', version);
  console.log('   Build date:', buildDate);
  console.log('************************************************');
}
